'use strict';

let _ = require('lodash');

let AttributeFactory = require('./../Attribute/index');
let Factory = require('./../index');
let WhiteList = require('./../../WhiteList/index');

class WhiteListFactory extends Factory {
    /**
     * Creates a valid white list given the configuration
     * @param  {Object[]} attributeConfigs The array of configurations to use to build the white list.
     * @return {Object}        An white list class object.
     */
    static create(attributeConfigs) {
        Factory._validate(attributeConfigs);

        let attributes = createWhiteListAttributes(attributeConfigs);
        return new WhiteList(attributes);
    }
}

module.exports = WhiteListFactory;

function createWhiteListAttributes(attributeConfigs) {
    return _.map(attributeConfigs, (attributeConfig) => {
        const attribute = AttributeFactory.create(attributeConfig);
        attribute.attributeValueTranslations = attributeConfig.attributeValueTranslations;
        attribute.includeOnOrder = attributeConfig.includeOnOrder;

        return attribute;
    });
}
